module.exports = __webpack_public_path__ + "img/menu-health-active.d2f910eb.svg";